/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { doEncryptLocal } from '@express-labs/raven-tools';
import EmptyStateModal from './subcomponents/EmptyStateModal';
import { analyze } from '../../../../helpers';
import OffersModal from './subcomponents/OffersModal';
import { LOCAL_STORAGE_SECRET } from '../../../../constants';
import getFromStorage from '../../../../helpers/storage/storage';
import s from './MemberWalletHeader.module.scss';

function MemberWalletHeader({ appliedCode, data }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const getLocalStorageData = (key) => key && localStorage.getItem(key);
  const availableOffers = (data && data.memberWallet && data.memberWallet.memberWalletOffers) || [];
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData');
  const encryptedFirstName = getLocalStorageData('firstName') || false;
  const decryptedFirstName = encryptedFirstName
    && doEncryptLocal.doDecrypt(LOCAL_STORAGE_SECRET, encryptedFirstName);

  useEffect(() => {
    if (isOpen && typeof analyze === 'function') {
      analyze({
        name: 'REACTReady',
        props: {},
        data,
      });
    }
  }, [isOpen, data]);

  return (
    <div className={s.memberWalletContainer} data-qm-encrypt>
      {loyaltyWarmStateData && decryptedFirstName && `Hi ${decryptedFirstName}, See your `}
      <button
        type="button"
        className={s.memberWalletButton}
        aria-expanded
        aria-label="Member Wallet Header"
        data-open
        onClick={openModal}
      >
        {loyaltyWarmStateData && decryptedFirstName ? 'latest offers' : 'see all offers'}
      </button>
      {isOpen && !availableOffers.length && <EmptyStateModal onClose={closeModal} />}
      {isOpen && availableOffers.length > 0 && (
        <OffersModal
          onClose={closeModal}
          availableOffers={availableOffers}
          appliedCode={appliedCode}
        />
      )}
    </div>
  );
}

MemberWalletHeader.propTypes = {
  data: PropTypes.shape({
    memberWallet: PropTypes.shape({
      memberWalletOffers: PropTypes.arrayOf(
        PropTypes.shape({}),
      ),
    }),
  }),
  appliedCode: PropTypes.string,
};

export default MemberWalletHeader;
